import StatusPill from '../../../components/ui/StatusPill/StatusPill';
import './ProjectHero.css';

export default function ProjectHero({ project, onViewGallery }) {
  const { name, location, shortDescription, status, hero, gallery, imageMode } = project;
  const hasGallery = gallery && gallery.length > 0;

  const media = (
    <picture>
      {hero.srcWebp && <source srcSet={hero.srcWebp} type="image/webp" />}
      <img
        src={hero.src}
        alt={hero.alt}
        width={hero.width}
        height={hero.height}
        fetchPriority="high"
      />
    </picture>
  );

  // Flyer mode: the flyer carries the project name, location and details, so it
  // is shown whole (uncropped) as a banner with a slim action bar beneath it —
  // no dark scrim, no overlaid copy.
  if (imageMode === 'flyer') {
    return (
      <section className="pd-hero pd-hero--flyer">
        <div className="pd-hero__flyer">{media}</div>
        <div className="pd-hero__bar">
          <div className="pd-hero__bar-meta">
            <StatusPill status={status} />
            <h1 className="pd-hero__bar-title">{name}</h1>
          </div>
          <div className="pd-hero__actions">
            <a href="#enquire" className="btn btn--dark">Enquire Now</a>
            {hasGallery && (
              <button type="button" className="btn btn--outline" onClick={onViewGallery}>
                View Gallery
              </button>
            )}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="pd-hero">
      <div className="pd-hero__media">
        {media}
        <div className="pd-hero__scrim" />
      </div>

      <div className="pd-hero__content">
        <StatusPill status={status} onDark />
        <h1 className="pd-hero__title">{name}</h1>
        <p className="pd-hero__loc">{location.display}</p>
        <p className="pd-hero__sub">{shortDescription}</p>
        <div className="pd-hero__actions">
          <a href="#enquire" className="btn btn--dark">Enquire Now</a>
          {hasGallery && (
            <button type="button" className="btn btn--ghost-white" onClick={onViewGallery}>
              View Gallery
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
